// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../Assets/selectArrow.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.finalPlace{
  font-weight: 500;
  font-size: 20px;
  }
  .result-accordion-item{
    background-color: transparent !important;
  }
  .result-accordion .accordion-button::after{
    display: none;
  }
  .comp-code{
    color:#68ad3f;
    font-size: 18px;
  }
  
  .result-accordion button{
    background-color: #FAFAFA !important;
    display: flex;
    justify-content: space-between;
    padding-left:0 !important;
    padding-right:0 !important;
    padding-bottom: 1px !important;
  border-bottom: 1px solid rgb(204, 198, 198);
  border-bottom-right-radius: 0 !important;
  border-bottom-left-radius:0 !important;
  }
  .result-accordion button:focus{
  border-bottom: 1px solid rgb(204, 198, 198) !important;
  }
  .comment-box-div{
    max-height:500px;
    overflow-y:scroll;
  }
.nineJudgeHead{
  writing-mode: vertical-lr;
  -webkit-writing-mode: vertical-lr;
  transform: rotate(180deg);
  display:flex
}

.resultSelect,.resultInput {
  height: 60px;
  font-size: 16px;
  -webkit-appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: 4.2%;
  background-position: top 50% right 7%;
  border: 1px solid #68ad3f !important;
  width: 300px;
  color: #424242;
  padding: 0px 15px !important;
}
.resultInput{
  background: none !important;
  background-color: white !important;
  border-radius: 4px;
}
.resultInput:focus-visible{
  outline:none !important;
}
.event-judge-name {
  font-weight: 500;
  color: #68ad3f;
}

.event-points {
  color: #424242;
}

.event-comments {
  font-size: 18px;
  color: #424242;
}

.dancer-count {
  font-size: 18px;
  color: #000000;
}

.table1 tr:first-child td,
.table1 tr:nth-child(2) td,
.table3 tr:first-child td,
.table3 tr:nth-child(2) td {
  color: #424242;
}

.table1 td,
.table3 td {
  color: #303030;
}

.golive-section {
  left: 0;
  right: 0;
  overflow-y: auto;
  top: 239px;
  height: calc(100vh - 239px);
  background: #fafafa;
}

.golive-section::-webkit-scrollbar {
  display: none !important;
}
.mob-result-card{
  display:none;
}


@media only screen and (min-width: 0px) and (max-width: 767px) {
  .web-result-card{
    display:none
  }
  .mob-result-card{
    display:block
  }
  .event-judge-name {
    font-size: 16px;
  }
  .event-judge-name-mob{
    font-size:18px;
    color:#68ad3f;
  }
  .judge-final-score-mob{
    font-size:18px;
    color:#FBB040;
  }

  .event-points {
    font-size: 15px;
  }

  .event-comments {
    font-size: 12px;
  }

  .dancer-count {
    font-size: 16px;
    margin-top: 20px;
  }

  .table1 td {
    font-size: 9px;
  }

  .result-btns {
    font-size: 12px !important;
    margin-top: 5px !important;
  }
  .comp-code{
    font-size:15px !important;
  }
}

@media only screen and (min-width: 767px) and (max-width: 1284px) {
  .event-judge-name {
    font-size: 14px;
  }
  .event-points {
    font-size: 13px;
  }

  .event-comments {
    font-size: 14px;
  }

  .dancer-count {
    font-size: 16px;
  }

  .table3 td {
    font-size: 10px;
  }
}

.table1,
.table3 {
  border-collapse: separate;
  border-spacing: 0;
  border: 0.5px solid #dcdcdc;
  border-radius: 4px;
  -moz-border-radius: 4px;
  -webkit-border-radius: 4px;
}

.table1,
.table3 tr:first-of-type td:first-of-type {
  border-top-left-radius: 4px;
}

.table1,
.table3 tr:first-of-type td:last-of-type {
  border-top-right-radius: 4px;
}

.table1,
.table3 tr:last-of-type td:first-of-type {
  border-bottom-left-radius: 4px;
}

.table1,
.table3 tr:last-of-type td:last-of-type {
  border-bottom-right-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/Parent/Results/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,eAAe;EACf;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,oCAAoC;IACpC,aAAa;IACb,8BAA8B;IAC9B,yBAAyB;IACzB,0BAA0B;IAC1B,8BAA8B;EAChC,2CAA2C;EAC3C,wCAAwC;EACxC,sCAAsC;EACtC;EACA;EACA,sDAAsD;EACtD;EACA;IACE,gBAAgB;IAChB,iBAAiB;EACnB;AACF;EACE,yBAAyB;EACzB,iCAAiC;EACjC,yBAAyB;EACzB;AACF;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,wBAAwB;EACxB,yDAAqD;EACrD,4BAA4B;EAC5B,qBAAqB;EACrB,qCAAqC;EACrC,oCAAoC;EACpC,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,kBAAkB;AACpB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,YAAY;AACd;;;AAGA;EACE;IACE;EACF;EACA;IACE;EACF;EACA;IACE,eAAe;EACjB;EACA;IACE,cAAc;IACd,aAAa;EACf;EACA;IACE,cAAc;IACd,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,0BAA0B;EAC5B;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;;EAEE,yBAAyB;EACzB,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC","sourcesContent":[".finalPlace{\n  font-weight: 500;\n  font-size: 20px;\n  }\n  .result-accordion-item{\n    background-color: transparent !important;\n  }\n  .result-accordion .accordion-button::after{\n    display: none;\n  }\n  .comp-code{\n    color:#68ad3f;\n    font-size: 18px;\n  }\n  \n  .result-accordion button{\n    background-color: #FAFAFA !important;\n    display: flex;\n    justify-content: space-between;\n    padding-left:0 !important;\n    padding-right:0 !important;\n    padding-bottom: 1px !important;\n  border-bottom: 1px solid rgb(204, 198, 198);\n  border-bottom-right-radius: 0 !important;\n  border-bottom-left-radius:0 !important;\n  }\n  .result-accordion button:focus{\n  border-bottom: 1px solid rgb(204, 198, 198) !important;\n  }\n  .comment-box-div{\n    max-height:500px;\n    overflow-y:scroll;\n  }\n.nineJudgeHead{\n  writing-mode: vertical-lr;\n  -webkit-writing-mode: vertical-lr;\n  transform: rotate(180deg);\n  display:flex\n}\n\n.resultSelect,.resultInput {\n  height: 60px;\n  font-size: 16px;\n  -webkit-appearance: none;\n  background-image: url('../../Assets/selectArrow.png');\n  background-repeat: no-repeat;\n  background-size: 4.2%;\n  background-position: top 50% right 7%;\n  border: 1px solid #68ad3f !important;\n  width: 300px;\n  color: #424242;\n  padding: 0px 15px !important;\n}\n.resultInput{\n  background: none !important;\n  background-color: white !important;\n  border-radius: 4px;\n}\n.resultInput:focus-visible{\n  outline:none !important;\n}\n.event-judge-name {\n  font-weight: 500;\n  color: #68ad3f;\n}\n\n.event-points {\n  color: #424242;\n}\n\n.event-comments {\n  font-size: 18px;\n  color: #424242;\n}\n\n.dancer-count {\n  font-size: 18px;\n  color: #000000;\n}\n\n.table1 tr:first-child td,\n.table1 tr:nth-child(2) td,\n.table3 tr:first-child td,\n.table3 tr:nth-child(2) td {\n  color: #424242;\n}\n\n.table1 td,\n.table3 td {\n  color: #303030;\n}\n\n.golive-section {\n  left: 0;\n  right: 0;\n  overflow-y: auto;\n  top: 239px;\n  height: calc(100vh - 239px);\n  background: #fafafa;\n}\n\n.golive-section::-webkit-scrollbar {\n  display: none !important;\n}\n.mob-result-card{\n  display:none;\n}\n\n\n@media only screen and (min-width: 0px) and (max-width: 767px) {\n  .web-result-card{\n    display:none\n  }\n  .mob-result-card{\n    display:block\n  }\n  .event-judge-name {\n    font-size: 16px;\n  }\n  .event-judge-name-mob{\n    font-size:18px;\n    color:#68ad3f;\n  }\n  .judge-final-score-mob{\n    font-size:18px;\n    color:#FBB040;\n  }\n\n  .event-points {\n    font-size: 15px;\n  }\n\n  .event-comments {\n    font-size: 12px;\n  }\n\n  .dancer-count {\n    font-size: 16px;\n    margin-top: 20px;\n  }\n\n  .table1 td {\n    font-size: 9px;\n  }\n\n  .result-btns {\n    font-size: 12px !important;\n    margin-top: 5px !important;\n  }\n  .comp-code{\n    font-size:15px !important;\n  }\n}\n\n@media only screen and (min-width: 767px) and (max-width: 1284px) {\n  .event-judge-name {\n    font-size: 14px;\n  }\n  .event-points {\n    font-size: 13px;\n  }\n\n  .event-comments {\n    font-size: 14px;\n  }\n\n  .dancer-count {\n    font-size: 16px;\n  }\n\n  .table3 td {\n    font-size: 10px;\n  }\n}\n\n.table1,\n.table3 {\n  border-collapse: separate;\n  border-spacing: 0;\n  border: 0.5px solid #dcdcdc;\n  border-radius: 4px;\n  -moz-border-radius: 4px;\n  -webkit-border-radius: 4px;\n}\n\n.table1,\n.table3 tr:first-of-type td:first-of-type {\n  border-top-left-radius: 4px;\n}\n\n.table1,\n.table3 tr:first-of-type td:last-of-type {\n  border-top-right-radius: 4px;\n}\n\n.table1,\n.table3 tr:last-of-type td:first-of-type {\n  border-bottom-left-radius: 4px;\n}\n\n.table1,\n.table3 tr:last-of-type td:last-of-type {\n  border-bottom-right-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
